import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './ProductCard.css';

export default function ProductCard({ produit }) {
  const { addItem } = useCart();
  const { id, nom, prix, images = [], categorie, stock = 10, nouveaute = false, promo = false, prix_barre } = produit;

  const imgPrincipale = images[0] || `https://placehold.co/400x500/1a1a1a/c9a84c?text=${encodeURIComponent(nom)}`;
  const rupture = stock === 0;
  const stockLimite = stock > 0 && stock <= 5;

  function handleAdd(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!rupture) addItem(produit);
  }

  return (
    <article className={`product-card${rupture ? ' product-card--rupture' : ''}`}>
      <Link to={`/produit/${id}`} className="product-card__img-wrap">
        <img src={imgPrincipale} alt={nom} className="product-card__img" loading="lazy" />
        <div className="product-card__badges">
          {nouveaute && <span className="badge">Nouveau</span>}
          {promo && <span className="badge" style={{ background: '#e05252', color: '#fff' }}>Promo</span>}
          {stockLimite && !rupture && <span className="badge badge-outline">Stock limité</span>}
          {rupture && <span className="badge" style={{ background: '#555', color: '#aaa' }}>Épuisé</span>}
        </div>
      </Link>
      <div className="product-card__body">
        <div className="product-card__meta">
          <span className="product-card__categorie">{categorie}</span>
          <Link to={`/produit/${id}`} className="product-card__nom">{nom}</Link>
        </div>
        <div className="product-card__footer">
          <div className="product-card__prix-wrap">
            {prix_barre && <span className="product-card__prix-barre">{prix_barre.toFixed(2)} €</span>}
            <span className="product-card__prix">{Number(prix).toFixed(2)} €</span>
          </div>
          <button
            className={`product-card__btn${rupture ? ' product-card__btn--disabled' : ''}`}
            onClick={handleAdd}
            disabled={rupture}
            aria-label={rupture ? `${nom} — épuisé` : `Ajouter ${nom} au panier`}
          >
            {rupture ? '✕' : '+'}
          </button>
        </div>
      </div>
    </article>
  );
}